import React from 'react';
import { motion } from 'framer-motion';
const experiences = [{
  company: 'Bahia Associates',
  title: 'Head of Risk & Treasury',
  date: '2020 – Present',
  location: 'New York City Metropolitan Area',
  bullets: ['Independent risk and treasury advisory for financial institutions and corporate clients', 'Specialized in enterprise risk frameworks, liquidity optimization, and regulatory strategy', 'Advised C-suite executives and boards on capital allocation strategies and risk governance']
}, {
  company: 'Mastercard International',
  title: 'Director, Head of Risk & Treasury',
  date: '2018 – 2020',
  location: 'New York',
  bullets: ['Built enterprise-wide risk management framework spanning market, credit, and operational risk across 60+ countries', 'Directed $15B+ treasury portfolio optimization, improving yield by 45bps while maintaining AAA-equivalent liquidity standards', 'Led ISDA/CSA negotiation strategy with 30+ global counterparties, reducing collateral requirements by $2.1B', 'Established risk governance committee reporting directly to CFO and Board Risk Committee']
}, {
  company: 'Société Générale / Newedge',
  title: 'Director, Global Head of Counterparty Risk',
  date: '2012 – 2018',
  location: 'New York/Paris',
  bullets: ['Managed counterparty credit exposure portfolio exceeding $50B notional across derivatives and prime brokerage', 'Designed and implemented real-time counterparty risk monitoring platform, reducing exposure breach incidents by 78%', 'Led cross-functional team of 45 risk professionals across New York, London, Paris, and Hong Kong', 'Drove regulatory alignment initiatives for EMIR and Dodd-Frank central clearing mandates']
}, {
  company: 'Accenture',
  title: 'Senior Manager, Financial Services Risk Practice',
  date: '2006 – 2012',
  location: 'New York/London',
  bullets: ['Advised Fortune 500 financial institutions on Basel II implementation and operational risk frameworks', 'Led 20+ enterprise risk transformation engagements totaling $180M+ in consulting revenue', "Designed risk data architecture for a top-5 global bank's credit risk platform"]
}, {
  company: 'Goldman Sachs',
  title: 'Vice President, Treasury & Capital Markets',
  date: '2001 – 2006',
  location: 'New York',
  bullets: ['Managed firm-wide liquidity risk framework and $25B short-term funding portfolio', 'Navigated 2008 financial crisis: restructured counterparty exposure, securing $3.2B in emergency liquidity facilities', 'Developed proprietary capital allocation model adopted across three business divisions', 'Led derivatives pricing and hedging strategy for interest rate and FX portfolios']
}, {
  company: 'Texaco Inc.',
  title: 'Senior Treasury Manager',
  date: '1996 – 2001',
  location: 'Houston',
  bullets: ['Managed corporate FX hedging program covering $4B+ annual commodity and currency exposures', 'Implemented first derivatives trading desk within corporate treasury function', 'Negotiated ISDA Master Agreements with 15+ bank counterparties']
}];
export function Experience() {
  return <section id="experience" className="py-24 bg-background" data-id="element-42">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12" data-id="element-43">
        {/* Section Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-14" data-id="element-44">
          <h3 className="font-serif text-3xl md:text-4xl font-bold text-primary tracking-wide uppercase" data-id="element-45">
            Professional Experience
          </h3>
          <div className="w-full h-[2px] bg-gradient-to-r from-gold via-gold/60 to-transparent mt-4" data-id="element-46"></div>
        </motion.div>

        {/* Timeline */}
        <div className="space-y-0" data-id="element-47">
          {experiences.map((exp, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="relative pl-10 pb-12 last:pb-0" data-id="element-48">
              {/* Timeline Line */}
              {index < experiences.length - 1 && <div className="absolute left-[7px] top-3 bottom-0 w-[2px] bg-gold/30" data-id="element-49"></div>}

              {/* Timeline Dot */}
              <div className="absolute left-0 top-1.5 w-[16px] h-[16px] rounded-full border-[3px] border-gold bg-white z-10" data-id="element-50"></div>

              {/* Card Content */}
              <div className="bg-white border border-slate-100 rounded-sm px-6 md:px-8 py-6 shadow-sm" data-id="element-51">
                {/* Header Row */}
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2 mb-1" data-id="element-52">
                  <div data-id="element-53">
                    <h4 className="font-sans text-lg font-bold text-primary leading-snug" data-id="element-54">
                      {exp.title}
                    </h4>
                    <p className="font-sans text-accent text-sm font-medium mt-1" data-id="element-55">
                      {exp.company} – {exp.location}
                    </p>
                  </div>
                  <span className="shrink-0 font-sans text-xs font-semibold text-primary border border-primary/20 rounded px-3 py-1.5 tracking-wide self-start" data-id="element-56">
                    {exp.date}
                  </span>
                </div>

                {/* Bullets */}
                <ul className="mt-5 space-y-3" data-id="element-57">
                  {exp.bullets.map((bullet, bIndex) => <li key={bIndex} className="flex items-start gap-3 text-charcoal font-sans text-sm leading-relaxed" data-id="element-58">
                      <span className="text-gold text-xs mt-1.5 shrink-0" data-id="element-59">
                        ◆
                      </span>
                      <span data-id="element-60">{bullet}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}